import { create } from 'zustand';
import { useShallow } from 'zustand/react/shallow';
import { errorLogger } from '@utils/errorLogger.util';
import { fetchQrSummation } from '../lib/api/fetchQrSummation';

const initialCheckMeta = {
  next_min_sum: 500,
  check_sum: 0,
  total_sum: 0,
  tickets_num: 0,
  next_tickets_num: 1,
};

export const useQrSummationStore = create((set, get) => ({
  redirectTo: '/progress',
  qrRequestPath: 'check_summation',
  loading: false,
  error: null,
  checkMeta: initialCheckMeta,

  fetchQrSummation: async (data) => {
    set({ loading: true, error: null });
    set({ checkMeta: initialCheckMeta });

    try {
      const {
        success,
        message,
        next_min_sum,
        total_value,
        total_sum,
        tickets_num,
        next_tickets_num,
      } = await fetchQrSummation(data, get().qrRequestPath);

      if (!success) {
        set({ error: message });
        return;
      }

      set({
        error: null,
        checkMeta: {
          total_value,
          next_min_sum,
          total_sum,
          tickets_num,
          next_tickets_num,
        },
      });
    } catch (error) {
      errorLogger.error(error, { source: useQrSummationStore.name });
      set({ error: 'Error during getting Qr code data. Please try again.' });
    } finally {
      set({ loading: false });
    }
  },

  setError: (error) => set({ error: error, loading: false }),
  setRequestPath: (path) => set({ qrRequestPath: path }),
}));

export const useQrSummationData = () => {
  return useQrSummationStore(
    useShallow((state) => ({
      fetchQrSummation: state.fetchQrSummation,
      qrError: state.error,
      isQrCodeLoading: state.loading,
      qrMessage: state.message,
      checkMeta: state.checkMeta,
      setError: state.setError,
      setRequestPath: state.setRequestPath,
      redirectTo: state.redirectTo,
    })),
  );
};
